import PropTypes from 'prop-types';
import React from 'react';
import { NavbarPrimaryMobileDropdownNavItem } from './NavbarPrimaryMobileDropdownNavItem';
import { NavbarPrimarySingleNavItem } from './NavbarPrimarySingleNavItem';

const NavbarPrimaryMobileItem = ({ nav, page, sanity }) =>
  nav?.type === 'single' ? (
    <NavbarPrimarySingleNavItem nav={nav} page={page} sanity={sanity} />
  ) : (
    <NavbarPrimaryMobileDropdownNavItem nav={nav} page={page} sanity={sanity} />
  );

NavbarPrimaryMobileItem.propTypes = {
  nav: PropTypes.shape({
    type: PropTypes.string.isRequired,
    // Add additional properties as needed.
  }).isRequired,
  page: PropTypes.shape({}).isRequired,
  sanity: PropTypes.shape({}).isRequired,
};

export { NavbarPrimaryMobileItem };
